module.exports = __webpack_public_path__ + "static/media/purple_circles.8219de08.svg";